// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UgYlcRps39kYGqqsk4Go {
    max-width: 100%;
    margin: 0 auto;
    padding: 16px 0;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/AvailabilityShared/AvailabilityShared.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB","sourcesContent":[".container {\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UgYlcRps39kYGqqsk4Go`
};
export default ___CSS_LOADER_EXPORT___;
